/* DOHA MODE scroll-in reveal — tiny, dependency-free, respects reduced-motion.
   Adds .is-in to any [.d-reveal] when it scrolls into view. Loaded `defer`. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function showAll() {
    document.querySelectorAll('.d-reveal').forEach(function (el) { el.classList.add('is-in'); });
  }
  if (reduce || !('IntersectionObserver' in window)) { showAll(); return; }

  function bind() {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    document.querySelectorAll('.d-reveal').forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else { bind(); }
})();
